import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { useAlert } from "react-alert";
import loginImage from "../assets/images/dashboardLogin.gif";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import keyIcon from "../assets/images/keyIcon.svg";
import ReEnterPassword from "./ReEnterPassword";

const ResetPassword = () => {
  const history = useHistory();
  const [username, setUsername] = useState("");
  const [showResetPasswordView, setShowResetPasswordView] = useState(false);
  const [initialResetLoader, setInitialResetLoader] = useState(false);
  const alert = useAlert();

  const submitUsername = async (e) => {
    e.preventDefault();
    setInitialResetLoader(true);
    const body = {
      username: username,
    };
    const resetPasswordConfig = {
      method: "Post",
      url: "https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/client/forgotpassword",
      data: JSON.stringify(body),
    };
    try {
      const resetPasswordResponse = await axios(resetPasswordConfig);
      console.log("resetPasswordResponse", resetPasswordResponse);
      if (resetPasswordResponse?.data?.isSuccess) {
        setShowResetPasswordView(true);
      }
    } catch (e) {
      alert.error("Something went wrong. Please try again");
    }
    setInitialResetLoader(false);
  };

  console.log("asdasd", initialResetLoader);

  return (
    <div
      style={{
        background: "#E9F5FE",
        minHeight: "100vh",
        padding: "18px 50px 40px",
      }}
      className="d-flex flex-column"
    >
      <nav>
        <Row className="justify-content-md-start">
          <img
            style={{ height: "50px", width: "200px" }}
            alt="logo"
            src="https://niroggyan.s3.ap-south-1.amazonaws.com/new-billing-dashboard-files/logos/niroggyan-logo.svg"
          />
        </Row>
      </nav>

      <Row
        className="justify-content-md-center align-items-center mt-5"
        style={{ flexGrow: 1 }}
      >
        <Col lg={6} style={{ flexGrow: 1, alignSelf: "stretch" }}>
          <div
            style={{
              background: "#fff",
              borderRadius: "30px",
              width: "90%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1px solid #D7D7D7",
            }}
          >
            <img src={loginImage} alt="landing-logo" width="60%" />
          </div>
        </Col>
        <Col
          xs={12}
          md={6}
          lg={4}
          className="rounded-lg d-flex flex-column align-items-center"
          style={{ borderRadius: "10px", flexGrow: 1.5 }}
        >
          {showResetPasswordView ? (
            <ReEnterPassword username={username} />
          ) : (
            <>
              <Box
                mb={3}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "60%",
                }}
              >
                <Box
                  mb={3}
                  sx={{
                    outline: "10px solid #F9F5FF",
                    width: "28px",
                    height: "28px",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={keyIcon}
                    alt="key icon"
                    width="80%"
                    height="80%"
                    style={{ objectFit: "contain" }}
                  />
                </Box>
                <Typography variant="h5">Forgot password?</Typography>
                <Typography
                  variant="body4"
                  sx={{ color: "#475467", fontWeight: 400 }}
                >
                  No worries, we’ll send you reset instructions.
                </Typography>
              </Box>
              <form style={{ width: "60%" }} onSubmit={submitUsername}>
                <Box>
                  <Typography variant="body6" mb={1}>
                    Username
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    required
                    fullWidth
                    label=""
                    variant="outlined"
                    size="small"
                    placeholder="Enter your username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    sx={{ borderRadius: "12px", background: "#fff" }}
                  />
                </Box>
                <Box my={3}>
                  <Button
                    sx={{ width: "100%" }}
                    type="submit"
                    disabled={initialResetLoader}
                  >
                    {initialResetLoader ? (
                      <CircularProgress size="20px" sx={{ color: "#fff" }} />
                    ) : (
                      "Continue"
                    )}
                  </Button>
                </Box>
                <Link to="/login">
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap={1}
                  >
                    <KeyboardBackspaceIcon sx={{ color: "#475467" }} />
                    <Typography variant="body5" sx={{ color: "#475467" }}>
                      Back to login
                    </Typography>
                  </Stack>
                </Link>
              </form>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ResetPassword;
